var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "20px",
    viewBox: "0 0 15 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0E438FC4-485D-42FF-9769-240387484F6C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screen---Mobile-example",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-8",
    transform: "translate(-69.000000, -738.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(28.000000, 731.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1020803,16.1676471 C47.043472,16.1676471 46.1822095,15.282066 46.1822095,14.1935438 C46.1822095,13.1050215 47.043472,12.2194405 48.1020803,12.2194405 C49.1606887,12.2194405 50.0221664,13.1050215 50.0221664,14.1935438 C50.0221664,15.282066 49.1606887,16.1676471 48.1020803,16.1676471 M48.1020803,10.7129842 C46.2129842,10.7129842 44.6757532,12.2743185 44.6757532,14.1935438 C44.6757532,16.112769 46.2129842,17.6741033 48.1020803,17.6741033 C49.9913917,17.6741033 51.5286227,16.112769 51.5286227,14.1935438 C51.5286227,12.2743185 49.9913917,10.7129842 48.1020803,10.7129842 M48.1010043,24.6763271 C47.5197274,24.030703 46.6001435,22.9546628 45.6850789,21.6563128 C43.7464849,18.9070301 42.7216643,16.4422525 42.7216643,14.5284075 C42.7216643,9.14045911 46.83967,8.72166428 48.1018651,8.72166428 C53.0940459,8.72166428 53.482066,13.1661406 53.482066,14.5284075 C53.482066,18.3175753 49.6272597,22.979627 48.1010043,24.6763271 M52.9330703,8.70832138 C51.6969154,7.60688666 49.9810617,7 48.1018651,7 C46.2226686,7 44.5068149,7.60688666 43.27066,8.70832138 C41.7850789,10.0322812 41,12.0446915 41,14.5284075 C41,19.938307 47.2257532,26.2774749 47.4906743,26.5445481 C47.6522956,26.7076758 47.8724534,26.7991392 48.1018651,26.7991392 C48.3312769,26.7991392 48.5514347,26.7076758 48.713056,26.5445481 C48.977977,26.2774749 55.2037303,19.938307 55.2037303,14.5284075 C55.2037303,12.0446915 54.4186514,10.0322812 52.9330703,8.70832138",
    id: "Fill-69"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.761f42bec7aae662f62f2d83b1e150ae.svg";
export { ForwardRef as ReactComponent };